jQuery(function($) {

  const contentListings = $('[data-content-listing-item]')

  function contentListing(selector) {
    const contentListing = $(selector)
    const readMoreToggle = contentListing.find('[data-read-more]')
    const expandableContent = contentListing.find('[data-expandable-content]')
    const mediaItems = contentListing.find('.media')
    const mediaSlider = contentListing.find('.slides')
    const hasNoTruncate = contentListing.find('.right_column').hasClass('no_truncate')

    if (mediaSlider.length) {
      initializeSlick(mediaSlider, {
        accessibility: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        arrows: false,
        autoplay: true,
        fade: true,
        pauseOnHover: false,
        nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
        prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>',
      });
    }

    mediaItems.on('click', function() {
      //if has class video_play return false
      if($(this).hasClass('video_playing')) {
        return false
      }
      
      //find iframe data-src attribute and populate src attribute with it, also add class video-active to media item
      const iframeSrc = $(this).find('iframe').attr('data-src')
      $(this).find('iframe').attr('src', iframeSrc)
      $(this).addClass('video_playing')
    })

    // Skip truncation logic if no_truncate is set
    if (hasNoTruncate) {
      return
    }

    $(window).on('load', function() {
      const expandableContentHeight = expandableContent.outerHeight()
      expandableContent.attr('data-height', expandableContentHeight)
      expandableContent.addClass('truncate')

      const truncatedContentHeight = expandableContent.outerHeight()
      expandableContent.attr('data-truncated-height', truncatedContentHeight)

      if(expandableContentHeight > 0 && expandableContentHeight > truncatedContentHeight) {
        expandableContent.height(expandableContent.attr('data-truncated-height'))
        readMoreToggle.removeClass('hidden')
        expandableContent.parent().addClass('expandable')
      }
    })

    readMoreToggle.on('click', function() {
      if(expandableContent.height() == expandableContent.attr('data-height')) {
        expandableContent.height(expandableContent.attr('data-truncated-height'))
      } else {
        expandableContent.height(expandableContent.attr('data-height'))
      }

      expandableContent.toggleClass('truncate')

      if(expandableContent.hasClass('truncate')) {
        readMoreToggle.text('Read More')
      } else {
        readMoreToggle.text('Read Less')
      }
      // readMoreToggle.toggleClass('active')
    })
  }

  if(contentListings.length) {
    //for each checlistGrids item pass selector into contentListing function
    contentListings.each(function() {
      new contentListing('#' + $(this).attr('id'))
    })
  }
});
